import { render, staticRenderFns } from "./instagram-order.vue?vue&type=template&id=1400c57e&"
import script from "./instagram-order.vue?vue&type=script&lang=js&"
export * from "./instagram-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports